export default "__VITE_ASSET__c1ecd48a__"